import PageHeader from '~/components/PageHeader';
import Stack from '~/components/ui/Stack';
import EventPass from './EventPass';
import PersonalData from './PersonalData';
import ProfileInformation from './ProfileInformation';
import ProfileOverview from './ProfileOverview';
// import Verification from './Verification';
// import SocialProfile from './SocialProfile';

export default function Profile() {
  return (
    <Stack col gap={8} className="flex-1 pb-4 compact:gap-5">
      <PageHeader id="yourProfile" />
      <div className="flex flex-col gap-7 compact:gap-5 compact:[&_.text-section-title]:text-[13px] compact:[&_.text-section-title]:mb-2.5">
        <ProfileOverview />
        <ProfileInformation />
        <PersonalData />
        {/* <Verification /> */}
        <EventPass />
        {/* <SocialProfile /> */}
      </div>
    </Stack>
  );
}
